import React from 'react';
import styled, { css } from 'styled-components';

import { ShelfImage } from 'assets/RepayYourLoansEarlyPage';
import {
  ArticleHeading,
  ArticleHyperlink,
  ArticleParagraph,
  ArticleSubHeading,
  ArticleImage,
} from 'components/Templates';
import { typography, minWidth } from 'themes';

const List = styled.ul`
  padding-inline-start: 24px;
`;

const SubList = styled.ul`
  padding-inline-start: 32px;
`;

const ListItem = styled.li`
  list-style-type: disc;
  margin-bottom: 8px;
  margin-top: 4px;
  ${typography('body-l')}
`;

const StyledArticleImage = styled(ArticleImage)`
  ${minWidth(
    'tablet',
    css`
      max-width: 320px;
    `
  )}
`;

export const GetDownToItSection = (
  <>
    <StyledArticleImage image={<ShelfImage />} />
    <ArticleHeading>Getting down to it</ArticleHeading>
    <ArticleParagraph>
      The terms and processes of early repayment will vary depending on the type of loan you have.
      Do check first if there are any penalties for early repayment.
    </ArticleParagraph>
    <ArticleSubHeading>Find out how you can do so:</ArticleSubHeading>
    <List>
      <ListItem>
        <ArticleHyperlink url="https://www.hdb.gov.sg/cs/infoweb/residential/servicing-your-hdb-housing-loan/loan-matters/payment ">
          HDB loan
        </ArticleHyperlink>{' '}
        (under partial capital repayment section)
      </ListItem>
      <ListItem>
        <ArticleHyperlink url="https://www.abs.org.sg/docs/library/carfinancing_english.pdf">
          Car loan
        </ArticleHyperlink>
      </ListItem>
      <ListItem>
        Student loan under the CPF education scheme
        <SubList>
          <ListItem>
            <ArticleHyperlink url="https://www.cpf.gov.sg/member/faq/other-schemes/cpf-education-loan-scheme/can-i-increase-the-monthly-instalment-for-my-education-repayment">
              Increase monthly payment
            </ArticleHyperlink>
          </ListItem>
          <ListItem>
            <ArticleHyperlink url="https://www.cpf.gov.sg/member/faq/other-schemes/cpf-education-loan-scheme/how-do-i-make-a-repayment-under-the-cpf-education-loan-scheme">
              Make lump sum repayment
            </ArticleHyperlink>
          </ListItem>
        </SubList>
      </ListItem>
    </List>
  </>
);
